// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__34Y3J","dragIcon":"SortableItem_dragIcon__3hR-V","disabled":"SortableItem_disabled__2_87t"};